/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Gray_Ostrich_HopeInputs */

const fr_fancy_gray_ostrich_hope = /** @type {(inputs: Fancy_Gray_Ostrich_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout développer`)
};

/**

* @param {Fancy_Gray_Ostrich_HopeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_gray_ostrich_hope = /** @type {((inputs?: Fancy_Gray_Ostrich_HopeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Gray_Ostrich_HopeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_gray_ostrich_hope(inputs)
});